import React from 'react'

export default function 
() {
  return (
    <div className='myskills' id='myskills'>
          <h1 className="title">MY SKILLS</h1>
          <div className='langages'  data-aos="fade-down" data-aos-duration="800">
            <p>JAVA EE</p>
            <p>JAVASCRIPT</p>
            <p>TYPESCRIPT</p>
          </div>
          <div className='langages'  data-aos="fade-right" data-aos-duration="800">
            <p>REACT.JS</p>
            <p>ANGULAR</p>
            <p>SPRING</p>
          </div>
          <div className='langages'  data-aos="fade-left" data-aos-duration="800">
            <p>MySQL</p>
            <p>SQLITE</p>
            <p>FIREBASE</p>
          </div>
          <div className='langages'  data-aos="fade-up" data-aos-duration="800">
            <p>HTML</p>
            <p>CSS</p>
            <p>UI/UX</p>
          </div>
    </div>
  )
}
